import { Controller } from "@hotwired/stimulus";

// Toggles `is-at-bottom` on the question list once the user has scrolled
// past the last item, so the bottom fade can drop and the last card isn't
// clipped by the mask with nothing below it.
export default class extends Controller {
  connect() {
    this.update = () => this.updateState();
    this.element.addEventListener("scroll", this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.element);
    this.updateState();
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.update);
    this.resizeObserver?.disconnect();
  }

  updateState() {
    const el = this.element;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 1;
    el.classList.toggle("is-at-bottom", atBottom);
  }
}
